import React from "react";
import WorkCard from "../WorkCard/WorkCard";
import "./WorkStyles.css";

const Work = () => {
  return (
    <div className="work-container">
      <div className="work-header">
        <h1>My Projects</h1>
        <p>Showcasing my passion for creating innovative digital solutions</p>
      </div>
      <div className="project-grid">
        <WorkCard />
      </div>
    </div>
  );
};

export default Work;
